"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Attribution = exports.FieldName = void 0;
var LogoColor_svg_1 = __importDefault(require("@ClientAssets/icons/LogoColor.svg"));
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var lodash_1 = require("lodash");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var Types_1 = require("../Types");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var FieldName;
(function (FieldName) {
    FieldName["OldTool"] = "oldTool";
    FieldName["Reason"] = "reason";
})(FieldName = exports.FieldName || (exports.FieldName = {}));
var Attribution = (function (_super) {
    __extends(Attribution, _super);
    function Attribution() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isComplete = false;
        _this.onComplete = function (values) { return __awaiter(_this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.props.onComplete(values)];
                    case 1:
                        _a.sent();
                        (0, mobx_1.runInAction)(function () {
                            _this.isComplete = true;
                        });
                        return [2];
                }
            });
        }); };
        return _this;
    }
    Attribution.prototype.render = function () {
        return react_1.default.createElement("div", { className: "customer-attribution" }, this.inner);
    };
    Object.defineProperty(Attribution.prototype, "inner", {
        get: function () {
            if (this.isComplete) {
                return (react_1.default.createElement("div", { className: "success-message-container" },
                    react_1.default.createElement("section", { className: "success-msg" },
                        react_1.default.createElement("h3", null, "Success!"),
                        react_1.default.createElement("p", null, "Thanks for subscribing to Qwilr. You're going to love it.")),
                    react_1.default.createElement("div", { className: "loading-notice" },
                        react_1.default.createElement("p", { className: "note" }, "Please wait a moment, while we refresh the app for your new experience..."),
                        react_1.default.createElement("div", { className: "loading-symbol" }))));
            }
            else {
                return (react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: "customer-attribution__header" },
                        react_1.default.createElement(kaleidoscope_1.SVG, { className: "customer-attribution__logo", src: LogoColor_svg_1.default }),
                        react_1.default.createElement("h2", { className: "customer-attribution__title" }, "Thanks for subscribing!")),
                    react_1.default.createElement(kaleidoscope_2.Form, { fields: [
                            {
                                id: FieldName.OldTool,
                                type: kaleidoscope_2.FormType.Dropdown,
                                props: {
                                    label: "What tool were you using before Qwilr?",
                                    placeholder: "Select one",
                                    hasLongLabel: true,
                                    size: kaleidoscope_3.DropdownSize.Medium,
                                },
                                options: Types_1.competitors.map(function (name) {
                                    return {
                                        id: (0, lodash_1.camelCase)(name),
                                        name: name,
                                        isOtherOption: name === "Other",
                                    };
                                }),
                                validate: lodash_1.noop,
                                showOtherTextInput: true,
                                otherTextInputProps: {
                                    label: "Other tool name",
                                    placeholder: "What's the name of the tool?",
                                    size: kaleidoscope_2.TextInputSize.Medium,
                                },
                            },
                            {
                                id: FieldName.Reason,
                                type: kaleidoscope_2.FormType.Text,
                                props: {
                                    multiline: true,
                                    label: "What made you switch to Qwilr?",
                                    placeholder: "Let us know your thoughts",
                                    size: kaleidoscope_2.TextInputSize.Medium,
                                    labelSize: kaleidoscope_2.TextInputLabelSize.Medium,
                                },
                                validate: lodash_1.noop,
                            },
                        ], onComplete: this.onComplete })));
            }
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], Attribution.prototype, "isComplete", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_a = typeof JSX !== "undefined" && JSX.Element) === "function" ? _a : Object),
        __metadata("design:paramtypes", [])
    ], Attribution.prototype, "inner", null);
    Attribution = __decorate([
        mobx_react_1.observer
    ], Attribution);
    return Attribution;
}(react_1.default.Component));
exports.Attribution = Attribution;
